module.exports = __webpack_public_path__ + "img/vip.a1e505fa.png";